import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LoadingButton } from "@mui/lab";
import { Box, TextField, Typography } from "@mui/material";
import DarkLogo from "../assets/DarkLogo.png";
import { grey } from "@mui/material/colors";
import { GlobalContext } from "../GlobalContext";

const getBackground = (theme) => {
	const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	switch (theme) {
		case "light":
			return isMobile ? "transparent" : grey[50];
		case "dark":
			return isMobile ? "transparent" : grey[900];
		default:
			return "transparent";
	}
};

const getBorder = (theme) => {
	const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	switch (theme) {
		case "light":
			return isMobile ? "none" : "1px solid rgba(0, 0, 0, 0.12)";
		case "dark":
			return isMobile ? "none" : "1px solid rgba(255, 255, 255, 0.12)";
		default:
			return "none";
	}
};

export const Login = ({ redirect }) => {
	const navigate = useNavigate();
	const { loginWithToken } = useContext(GlobalContext);
	const [token, setToken] = useState("");
	const [error, setError] = useState(false);
	const [helperText, setHelperText] = useState("");
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const urlToken = urlParams.get("token");
		if (urlToken) {
			loginWithToken(urlToken);
			navigate(redirect);
		}
	}, [loginWithToken, navigate, redirect]);

	const handleSubmit = (event) => {
		event.preventDefault();
		setLoading(true);
		if (token.trim()) {
			loginWithToken(token.trim());
			navigate(redirect);
		} else {
			setError(true);
			setHelperText("Token requerido");
			setLoading(false);
		}
	};

	return (
		<Box
			sx={{
				width: 400,
				padding: 7,
				borderRadius: 5,
				border: (theme) => getBorder(theme.palette.mode),
				background: (theme) => getBackground(theme.palette.mode),
			}}
		>
			<form onSubmit={handleSubmit}>
				<center>
					<img
						src={DarkLogo}
						alt="logo-app"
						height={50}
						width={180}
						style={{ marginTop: 20, marginBottom: 40 }}
					/>
				</center>

				<TextField
					id="token"
					label="Token"
					variant="outlined"
					fullWidth
					value={token}
					onChange={(e) => {
						setToken(e.target.value);
						setError(false);
						setHelperText("");
					}}
					error={error}
					helperText={helperText}
				/>

				<LoadingButton
					sx={{ mt: 3, mb: 3, height: 50 }}
					type="submit"
					fullWidth
					variant="contained"
					color="primary"
					loading={loading}
					disableElevation
				>
					Ingresar
				</LoadingButton>

				<Typography sx={{ mt: 4, textAlign: "center" }}>Versión: 0.0.1b</Typography>
			</form>
		</Box>
	);
};
